var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('h2',[_vm._v("Home page")]),_c('hr'),_c('div',{staticClass:"nav"},[_c('router-link',{attrs:{"to":"/Calculator"}},[_vm._v("Калькулятор")]),_c('router-link',{attrs:{"to":"/Tracking"}},[_vm._v("Треккинг")]),_c('router-link',{attrs:{"to":"/Widget"}},[_vm._v("Виджет")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }